export enum PaymentOption {
    SIMPLE_PAY = 'Simple',
    CASH = 'Cash'
}

export interface Payment {
    paymentOption:string;
    paymentOptionToBackend: string;
    
}